import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ToolProducerSelectorViewModel extends SelectorBaseViewModel<ToolProducer> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<ToolProducer[]> {
        let result = await ServerConnection.callServer('/Complex/ProducerServices/ListAllProducers', {})
        return result.Producers.map(x => {
            let t = new ToolProducer(this);
            t.id = x.Id;
            t.title = `${x.Name} (${x.Country})`;
            return t;
        });
    }
}

export class ToolProducer extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}